<template>
  <app-modal
      :modal-id="modalId"
      :title="title"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
      modal-size="sm"
      modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{title}}</h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="
          selectedUrl
            ? `/accreditations/applications_historical_data/vigilances/${inputs.id}`
            : `/accreditations/applications_historical_data/vigilances`
        "
      >
        <div class="row h-100">
          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">
                Fecha del proceso
              </label>
              <app-input
                  id="inputs_accreditation_area_id"
                  type="date"
                  v-model="inputs.date"
                  :required="true"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">
                Tipo de proceso
              </label>
              <app-input
                  id="inputs_accreditation_activity_id"
                  type="select"
                  v-model="inputs.acc_type"
                  :list="processsList"
                  :required="true"
                  :disabled="disabled"
              />
            </div>
          </div>

          <div style="height: 200px"></div>

        </div>
      </form>
    </template>

    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>


  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin.js";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    dataInfo: Object
  },
  data() {
    return {
      preloader: false,
      inputs: {
      },
      organization: [],
      modalId: "add-edit-modal-pending",
      processList: [
          { id: "", value: this.$t("select_option") },
          {id: 6, value: 'Vigilancia 1'},
          {id: 7, value: 'Vigilancia 2'},
          {id: 9, value: 'Renovación'}
      ],
      disabledSubmit: false,
      disabled: false,
    };
  },
  created() {
      this.processList = [
        { id: "", value: this.$t("select_option") },
        { id: 6, value: 'Vigilancia 1' },
        { id: 7, value: 'Vigilancia 2' },
        { id: 9, value: 'Renovación' }
      ];

      this.inputs = {
        date: this.dataInfo.maintenance_date,
        acc_type: this.dataInfo.type_acc,
        id: this.dataInfo.id,
        id_accApp: this.$store.state.accreditation.id
      }

      if (this.dataInfo.type_acc) {
        this.disabled = true;
      }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (response.data.status == 0){
        this.$toastr.e(this.$t(response.data.message));
      }else{
        if (this.selectedUrl != "") {
          this.$toastr.s(this.$t("updated_success"));
        } else {
          this.$toastr.s(this.$t("created_success"));
        }
      }

      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      //this.inputs = response.data;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
    area() {
      return this.accreditation_area_id;
    },
    processsList() {
       let list = []; 
       console.log(this.selectedUrl); 
    if (this.$store.state.accreditation.app.accreditation_area_id == 2) {
      list = [
        { id: "", value: this.$t("select_option") },
        { id: 6, value: 'Vigilancia 1' },
        { id: 7, value: 'Vigilancia 2' },
        { id: 8, value: 'Vigilancia 3' },
        { id: 9, value: 'Renovación' }
      ];
    } else {
      list = [
        { id: "", value: this.$t("select_option") },
        { id: 6, value: 'Vigilancia 1' },
        { id: 7, value: 'Vigilancia 2' },
        { id: 9, value: 'Renovación' }
      ];
    }
      
      return list;
    },
  }
}
</script>

<style scoped>

</style>